import { render, staticRenderFns } from "./add-post-basic.vue?vue&type=template&id=43649426&scoped=true"
import script from "./add-post-basic.vue?vue&type=script&lang=js"
export * from "./add-post-basic.vue?vue&type=script&lang=js"
import style0 from "./add-post-basic.vue?vue&type=style&index=0&id=43649426&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43649426",
  null
  
)

export default component.exports